import AddonCore, { Mode } from "@hhanh/addon-core";
import { BrowserFetchPortAdapter, NodeCodecsPortAdapter } from "@hhanh/addon-core/adapters";
import { CheckoutRequestParams } from "@hhanh/addon-core/params";
import getPublicEnvironment from "@hhanh/addon-core/public-env";
import queryParser from "query-string";
import * as v from "voca";
import Vue from "vue";

const PROGRESS_BAR_MODAL = "progress-bar";

let addonCore = new AddonCore(
  new BrowserFetchPortAdapter(),
  new NodeCodecsPortAdapter()
)

function redirectToThank(plan){
  window.location.href = `/thank.html?message=${encodeURIComponent(plan.description)}`;
}

//---------------------------------------------------------------------------------
declare var paypal;
//---------------------------------------------------------------------------------
export default Vue.extend({
  data() {
    return {
      progressBarMessage: "Please Wait...",
      storeName: "2HAC STUDIO STORE CHECKOUT",
      listOfPlans: [],
      buyer: "",
      mode: null
    };
  },
  mounted: function () {
    const rawParam: string = queryParser.parse(location.search)["json"] as string;
    if (v.isBlank(rawParam)) {
      this.paymentError(new Error("Wrong service request"));
    }

    const params: CheckoutRequestParams = addonCore.decodeObject<CheckoutRequestParams>(rawParam);
    if (!this.validate(params)) return;
    this.mode = params.mode;
    addonCore = addonCore.withPublicEnvironment(getPublicEnvironment(params.mode));

    if (params.mode === Mode.DEVELOPMENT) {
      this.printTestParameter();
    }

    this.$modal.show(PROGRESS_BAR_MODAL, { clickToClose: false });
    this.buyer = params.id;

    const self = this;
    addonCore.getPaypalPlans(params.paypalPlanSets, `/${this.mode}/plans`)
      .then(plans => {
        self.listOfPlans = plans;
        self.$nextTick(() => {
          for (const plan of plans) {
            if (plan.billing_cycles[0].total_cycles > 1) {
              self.subscriptionButton("#button-" + plan.id, plan.id);
            } else self.orderButton("#button-" + plan.id, plan);
          }
        });
      }).then(() => self.$modal.hide(PROGRESS_BAR_MODAL))
      .catch(e => { self.$modal.hide(PROGRESS_BAR_MODAL); this.paymentError(e); });
  },

  methods: {

    paymentError(err: Error) {
      window.location.href = `/error.html?message=${encodeURIComponent(err.message)}`;
    },
    //---------------------------------------------------------------------------------
    validate(params: CheckoutRequestParams) {

      if (params.mode != Mode.DEVELOPMENT && params.mode != Mode.PRODUCTION) {
        this.paymentError(new Error("Wrong service request"));
        return false;
      }

      if (v.isBlank(params.id)) {
        this.paymentError(new Error("Wrong service request"));
        return false;
      }

      return true;
    },
    //---------------------------------------------------------------------------------
    subscriptionButton: function (elementId, planId) {
      const self = this;
      paypal.Buttons({
        createSubscription: function (data, actions) {
          return actions.subscription.create({
            plan_id: planId
          });
        },
        onApprove: function (data, actions) {
          self.subscriptionApprove(data, planId);
        },
        onError: function (err) {
          self.paymentError(err);
        }
      }).render(elementId);
    },
    //---------------------------------------------------------------------------------
    orderButton: function (elementId, plan) {
      const self = this;
      paypal.Buttons({
        createOrder: function (data, actions) {
          return actions.order.create({
            purchase_units: [{
              description: `${plan.name}`,
              amount: {
                currency_code: plan.billing_cycles[0].pricing_scheme.fixed_price.currency_code,
                value: plan.billing_cycles[0].pricing_scheme.fixed_price.value
              }
            }]
          });
        },
        onApprove: function (data, actions) {
          return actions.order.capture().then(function (details) {
            self.orderApprove(details, plan.id);
          });
        },
        onError: function (err) {
          self.paymentError(err);
        }
      }).render(elementId);
    },
    //---------------------------------------------------------------------------------
    subscriptionApprove: function (data, planId) {
      let plan = null;
      for( const p of this.listOfPlans){
        if (p.id === planId){
          plan = p;
        }
      }
      this.listOfPlans = [];
      this.$modal.show(PROGRESS_BAR_MODAL, { clickToClose: false });
      const self = this;
      addonCore.fetch(`/${self.mode}/checkout/${planId}/${self.buyer}`, {
        method: 'POST',
        body: JSON.stringify(data)
      }).then(res => {
        const json = JSON.parse(res);
        if (json["status"] === "OK") {
          redirectToThank(plan);
        } else {
          throw new Error("Internal server error");
        }
      }).catch(self.paymentError);
    },
    //---------------------------------------------------------------------------------
    orderApprove: function (data, planId) {
      let plan = null;
      for( const p of this.listOfPlans){
        if (p.id === planId){
          plan = p;
        }
      }
      this.listOfPlans = [];
      this.$modal.show(PROGRESS_BAR_MODAL, { clickToClose: false });
      const self = this;
      addonCore.fetch(`/${self.mode}/checkout/${planId}/${self.buyer}`, {
        method: 'POST',
        body: JSON.stringify(data)
      }).then(res => {
        const json = JSON.parse(res);
        if (json["status"] === "OK") {
          redirectToThank(plan);
        } else {
          throw new Error("Internal server error");
        }
      }).catch(self.paymentError);
    },
    //---------------------------------------------------------------------------------
    printTestParameter: function () {
      const devParams: CheckoutRequestParams = {
        id: "xxx",
        mode: Mode.DEVELOPMENT,
        paypalPlanSets: [
          {
            codes: [],
            plans: [
              "P-8SV8738322291870ELUGD6BI",
              "P-8NT637602L4907112LUIYESI",
            ]
          },
          {
            codes: ["CA"],
            plans: [
              "P-8SV8738322291870ELUGD6BI",
              "P-8NT637602L4907112LUIYESI",
              "P-5YL34049VC934342RLUVHMCI"
            ]
          }
        ]
      };
      console.log(`test param: ${btoa(JSON.stringify(devParams))}`);
    }
  }
});